import React, { useState, useEffect } from "react";
import { HeartOutlined, HeartFilled } from "@ant-design/icons";
import { Card, Typography, Rate, Tag } from "antd";
import { Link, useNavigate } from "react-router-dom";
import "./ListaServicioItem.scss";
import { obtenerNombreCategoria } from "../../utils/categorias/categoriaUtils";
import { useUser } from "../../context/UserContext";
import { toast } from "sonner";

const { Title, Text } = Typography;

export const ListaServiciosItemBuscador = ({
  servicio,
  favorite,
  isFavorite,
}) => {
  const { userData } = useUser();
  const navigate = useNavigate();
  const isMesesSinIntereses = servicio.mesesSinIntereses || false;
  const detalleUrl = `/servicio/${servicio.id}`;
  const [nombreCategoria, setNombreCategoria] = useState("");
  const [localIsFavorite, setLocalIsFavorite] = useState(isFavorite);
  const [buttonDisabled, setButtonDisabled] = useState(false);

  useEffect(() => {
    obtenerNombreCategoria(servicio.categoria)
      .then((nombre) => setNombreCategoria(nombre))
      .catch((error) => console.error("Error al obtener categoría:", error));
  }, [servicio.categoria]);

  useEffect(() => {
    setLocalIsFavorite(isFavorite);
  }, [isFavorite]);

  const handleToggleFavorite = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!buttonDisabled) {
      if (!userData) {
        toast.error("Inicia sesión para agregar a favoritos.");
        return;
      }
      favorite(!localIsFavorite);
      setLocalIsFavorite(!localIsFavorite);
      setButtonDisabled(true);
      setTimeout(() => setButtonDisabled(false), 1000);
    }
  };

  return (
    <Card
      hoverable
      className="service-card-item"
      onClick={() => navigate(detalleUrl)}
      cover={
        <div className="card-image-container">
          <Link to={detalleUrl} onClick={(e) => e.stopPropagation()}>
            <img alt={servicio.nombre} src={servicio.imagen[0]?.url} />
          </Link>
          <button
            onClick={handleToggleFavorite}
            className={`fav-button ${localIsFavorite ? 'active' : ''}`}
            disabled={buttonDisabled}
          >
            {localIsFavorite ? <HeartFilled /> : <HeartOutlined />}
          </button>
          {isMesesSinIntereses && (
            <div className="msi-badge-overlay"><span>MSI</span></div>
          )}
        </div>
      }
    >
      <div className="card-body-content">
        <Text className="category-tag" ellipsis>{nombreCategoria}</Text>
        <Title level={5} ellipsis={{ rows: 2 }} className="service-title">
          {servicio.nombre}
        </Title>

        <div className="service-hours">
          <Tag color="blue">{`${servicio.horaInicio} - ${servicio.horaFin}`}</Tag>
        </div>

        {isMesesSinIntereses && (
          <Text className="msi-text-promo">Hasta 12 meses sin intereses</Text>
        )}

        <div className="rating-section">
          <Rate disabled allowHalf value={servicio.calificacion || 0} />
          <span className="rating-count">({servicio.resennaCount || 0})</span>
        </div>
      </div>

      <div className="card-footer-price">
        <div className="price-container">
          <span className="currency">$</span>
          <span className="amount">{servicio.total}</span>
        </div>
      </div>
    </Card>
  );
};